exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.numbered[data-v-364566b8] {\n  margin-left: 1.2em;\n}\nol.numbered > li[data-v-364566b8] {\n  list-style: decimal;\n}\n.campaign-entry-img[data-v-364566b8] {\n  width: 75%;\n  margin-left: 5px;\n  display: block;\n}", ""]);

// exports
